const CtaButton = ({
  ctaText,
  dataTestId,
}: {
  ctaText: string;
  dataTestId?: string;
}) => {
  return (
    <button
      id="cta-button"
      type="button"
      aria-label={ctaText}
      className="bg-[#FF0000] text-white px-20 py-2 text-[22px] font-normal rounded-tl-[30px] rounded-br-[30px] min-w-[180px] hover:bg-[#8f000a] transition-colors"
      data-test-id={dataTestId || "cta-button"}
    >
      {ctaText}
    </button>
  );
};

export default CtaButton;
